import React from 'react';
import LoadingSpinner from './LoadingSpinner';

interface LoadingPageProps {
  message?: string;
  size?: number;
}

const LoadingPage: React.FC<LoadingPageProps> = ({ 
  message = 'Loading...', 
  size = 200 
}) => {
  return (
    <div 
      style={{ 
        minHeight: '100vh', 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center',
        fontFamily: 'Gabarito, sans-serif',
        backgroundColor: '#ffffff',
        gap: '20px'
      }}
    >
      <LoadingSpinner size={size} />
      {message && (
        <p 
          style={{
            fontSize: '18px',
            color: '#666',
            margin: 0,
            textAlign: 'center'
          }}
        >
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingPage; 